import { Coins, Eraser, HandCoins, List, LogOut, Menu, SearchCheck, ShoppingCart, Trophy, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { NavLink, useNavigate } from "react-router-dom";
import { useCarrinho } from "@/contexts/CarrinhoProvider";
import { useAuth } from "@/contexts/AuthProvider";
import clsx from "clsx";
import { labelPlural } from "@/utils/copyTituloBilhete";

export function AppHeaderModelo2Layout() {
    const { isAuthorized, deslogar, usuario, saldoDisponivel } = useAuth();
    const { qtdCarrinho, limparCarrinho } = useCarrinho();
    const navigate = useNavigate();

    async function handleLimparCarrinho() {
        await limparCarrinho()
        navigate('/')
    }

    return (
        <>
            <header className="bg-white pt-2 w-full fixed top-0 z-50">
                <div className="lg:px-36 2xl:px-96">
                    <div className="flex justify-between ms-2 ">
                        <NavLink className="flex h-16" to="/">
                            <img src={`/assets/${import.meta.env.VITE_APP_THEME}/logotipo.png`} />
                        </NavLink>

                        <div className="flex my-auto me-2">
                            {
                                qtdCarrinho > 0 && (
                                    <Button onClick={() => {
                                        {
                                            if (isAuthorized) {
                                                navigate('/compra/finalizar')
                                            } else {
                                                navigate('/Acessar?redirect=compra/finalizar')
                                            }
                                        }
                                    }} size="sm" variant="default">
                                        <ShoppingCart className={clsx("text-primary-foreground drop-shadow",
                                            {
                                                'text-secondary': import.meta.env.VITE_APP_THEME === "AcreCap"
                                            })
                                        } size="28" />
                                        <span id="qtdCarrinho" className={clsx("ms-4 text-lg text-primary-foreground drop-shadow",
                                            {
                                                'text-secondary': import.meta.env.VITE_APP_THEME === "AcreCap"
                                            })
                                        }>{qtdCarrinho}</span>
                                    </Button>
                                )
                            }

                            {
                                isAuthorized && (
                                    <Button onClick={() => navigate('/compra/creditos')} className="ms-2" size="sm" variant="default">
                                        <Coins size="28" className={clsx("text-primary-foreground drop-shadow",
                                            {
                                                'text-secondary': import.meta.env.VITE_APP_THEME === "AcreCap"
                                            })
                                        } />
                                        <span className={clsx("ms-4 text-lg text-primary-foreground drop-shadow",
                                            {
                                                'text-secondary': import.meta.env.VITE_APP_THEME === "AcreCap"
                                            })
                                        }>{saldoDisponivel.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                                    </Button>
                                )
                            }
                        </div>
                    </div>
                    <div className="flex justify-between mt-2">
                        <div className="hidden md:flex text-lg my-auto me-1 gap-4 ms-2">
                            <NavLink className={({ isActive }) => { return "underline " + (isActive ? 'text-primary/70' : 'text-primary') }} to='/'>
                                <span className="font-bold">INÍCIO</span>
                            </NavLink>
                            <NavLink className={({ isActive }) => { return "underline " + (isActive ? 'text-primary/70' : 'text-primary') }} to='/compra/titulos'>
                                <span className="font-bold">COMPRAR</span>
                            </NavLink>
                            {
                                isAuthorized && (
                                    <NavLink className={({ isActive }) => { return "underline " + (isActive ? 'text-primary/70' : 'text-primary') }} to='/compra/creditos'>
                                        <span className="font-bold">INSERIR CRÉDITOS</span>
                                    </NavLink>
                                )
                            }
                            <NavLink className={({ isActive }) => { return "underline " + (isActive ? 'text-primary/70' : 'text-primary') }} to='/resultados'>
                                <span className="font-bold">RESULTADOS</span>
                            </NavLink>
                        </div>
                        <div className="text-lg my-auto me-1 ms-2">
                            {
                                isAuthorized && usuario ? (
                                    <DropdownMenu>
                                        <DropdownMenuTrigger asChild>
                                            <Menu className="text-menu hover:cursor-pointer hover:brightness-150" size="40" />
                                        </DropdownMenuTrigger>
                                        <DropdownMenuContent align="end" className="text-menu w-screen md:w-56 md:me-1">
                                            <DropdownMenuLabel className="flex flex-col">

                                                <span>{usuario.Nome}</span>
                                                <span>{usuario.Email}</span>
                                            </DropdownMenuLabel>
                                            <NavLink to="/compra/titulos">
                                                <DropdownMenuItem className="cursor-pointer flex">
                                                    <HandCoins className="mt-1 mx-2 h-4 w-4" />
                                                    Comprar {labelPlural()}
                                                </DropdownMenuItem>
                                            </NavLink>
                                            <NavLink to='/compra/extrato-compras'>
                                                <DropdownMenuItem className="cursor-pointer flex">
                                                    <ShoppingCart className="mt-1 mx-2 h-4 w-4" />
                                                    Minhas Compras
                                                </DropdownMenuItem>
                                            </NavLink>
                                            <NavLink to='/resultados'>
                                                <DropdownMenuItem className="cursor-pointer flex">
                                                    <Trophy className="mt-1 mx-2 h-4 w-4" />
                                                    Resultados
                                                </DropdownMenuItem>
                                            </NavLink>
                                            <NavLink to='/conferir-resultado'>
                                                <DropdownMenuItem className="cursor-pointer flex">
                                                    <SearchCheck className="mt-1 mx-2 h-4 w-4" />
                                                    Conferir Resultados
                                                </DropdownMenuItem>
                                            </NavLink>
                                            <NavLink to='/compra/creditos'>
                                                <DropdownMenuItem className="cursor-pointer flex">
                                                    <Coins className="mt-1 mx-2 h-4 w-4" />
                                                    Comprar Créditos PIX
                                                </DropdownMenuItem>
                                            </NavLink>
                                            <NavLink to="/perfil">
                                                <DropdownMenuItem className="cursor-pointer flex ">
                                                    <User className="mt-1 mx-2 h-4 w-4" />
                                                    Meu Perfil
                                                </DropdownMenuItem>
                                            </NavLink>
                                            <NavLink to='/compra/extrato-creditos'>
                                                <DropdownMenuItem className="cursor-pointer flex">
                                                    <List className="mt-1 mx-2 h-4 w-4" />
                                                    Extrato de Creditos
                                                </DropdownMenuItem>
                                            </NavLink>
                                            <DropdownMenuItem onClick={handleLimparCarrinho} className="cursor-pointer flex">
                                                <Eraser className="mt-1 mx-2 h-4 w-4" />
                                                <span>Limpar Carrinho</span>
                                            </DropdownMenuItem>
                                            <DropdownMenuItem onClick={() => {
                                                deslogar()
                                                navigate('/')
                                            }}
                                                className="cursor-pointer flex">
                                                <LogOut className="mt-1 mx-2 h-4 w-4" />
                                                <span>Sair</span>
                                            </DropdownMenuItem>
                                        </DropdownMenuContent>
                                    </DropdownMenu>
                                ) : (
                                    <>
                                        <NavLink className="underline text-base text-primary font-bold" to='/Acessar'>
                                            Acessar
                                        </NavLink>
                                        &nbsp;ou&nbsp;
                                        <NavLink className="underline text-base text-primary font-bold" to='/Acessar?realizandoCadastro'>
                                            Cadastrar
                                        </NavLink>
                                    </>
                                )
                            }
                        </div>
                    </div>
                </div>
            </header >
            <div className="h-28 md:h-32 bg-white">
            </div>
        </>
    )
}
